document.addEventListener('DOMContentLoaded', function () {
  // const targetNode = document.querySelector('#photouploadapp');

  // if (targetNode) {
  //   const observer = new MutationObserver(function (mutationsList) {
  //     for (const mutation of mutationsList) {
  //       if (mutation.type === 'childList') {
  //         if (mutation.addedNodes) {
  //           for (const node of mutation.addedNodes) {
  //             if (node.nodeType === 1 && node.matches('.uploadcare--widget')) {
  //               const label = node.parentElement ? node.parentElement.querySelector('p[data-ph-product-id]') : null;
  //               if (label) {
  //                 applyStylesToLabel(label);
  //               }
  //               const uploadWidget = node;
  //               const uploadBtt = uploadWidget.querySelector('button.uploadcare--widget__button_type_open');
  //               if (uploadBtt) {
  //                 customizeUploadButtonText(uploadBtt);
  //               }
  //               applyStylesToUploadWidget(uploadWidget);
  //               startWatchingForFileName(uploadWidget);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });

  //   const config = { childList: true, subtree: true };
  //   observer.observe(targetNode, config);
  // }

  // Existing style and customization functions
  // function applyStylesToLabel(label) {
  //   label.style.color = 'var(--Black, #141414)';
  //   label.style.fontFamily = 'var(--typeBasePrimary), var(--typeBaseFallback)';
  //   label.style.fontSize = '15px';
  //   label.style.fontStyle = 'normal';
  //   label.style.fontWeight = '500';
  //   label.style.lineHeight = 'normal';
  //   label.style.marginBottom = '5px';
  // }

  // function applyStylesToUploadWidget(uploadWidget) {
  //   uploadWidget.style.display = 'block';
  // }

  // function customizeUploadButtonText(uploadBtt) {
  //   uploadBtt.innerHTML = '<p>Drag and drop your files or <span>browse</span></p>';
  //   uploadBtt.style.width = '100%';
  //   uploadBtt.style.minHeight = '80px';
  //   uploadBtt.style.background = '#EEE';
  // }

  // function startWatchingForFileName(uploadWidget) {
  //   const fileNameObserver = new MutationObserver(function (mutationsList) {
  //     for (const mutation of mutationsList) {
  //       if (mutation.type === 'childList') {
  //         if (mutation.addedNodes) {
  //           for (const node of mutation.addedNodes) {
  //             if (node.nodeType === 1 && node.matches('.uploadcare--widget__file-name')) {
  //               applyStylesToFileName(node);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });

  //   const fileNameConfig = { childList: true, subtree: true };
  //   fileNameObserver.observe(uploadWidget, fileNameConfig);
  // }

  // function applyStylesToFileName(fileNameNode) {
  //   fileNameNode.style.fontFamily = 'var(--typeBasePrimary), var(--typeBaseFallback)';
  //   fileNameNode.style.fontSize = '14px';
  //   fileNameNode.style.fontStyle = 'normal';
  //   fileNameNode.style.fontWeight = '600';
  //   fileNameNode.style.lineHeight = 'normal';
  //   fileNameNode.style.letterSpacing = '1.4px';
  //   fileNameNode.style.textTransform = 'uppercase';
  //   fileNameNode.style.borderRadius = '0';
  //   fileNameNode.style.padding = '19px';
  //   fileNameNode.style.background = '#467224';
  // }

  // Tab functionality
  const tabHeadings = Array.from(document.querySelectorAll('.tab-heading'));
  const tabContents = Array.from(document.querySelectorAll('.tab-content'));

  if (tabHeadings.length && tabContents.length) {
    const firstTab = tabHeadings[0];
    const lastTab = tabHeadings[tabHeadings.length - 1];

    tabHeadings.forEach((heading) => {
      heading.addEventListener('click', function () {
        return setActiveTab(heading);
      });

      heading.addEventListener('keydown', function (evt) {
        let currentTab = evt.currentTarget;

        switch (evt.key) {
          case 'ArrowLeft':
            selectPreviousTab(currentTab);
            break;

          case 'ArrowRight':
            selectNextTab(currentTab);
            break;

          case 'Home':
            setActiveTab(firstTab);
            break;

          case 'End':
            setActiveTab(lastTab);
            break;

          default:
            break;
        }
        evt.stopPropagation();
        evt.preventDefault();
      });
    });

    function setActiveTab(trigger) {
      const triggerIndex = tabHeadings.indexOf(trigger);

      if (trigger.classList.contains('active')) return;

      tabContents.forEach((content, contentIndex) => {
        content.classList.remove('active');

        if (triggerIndex === contentIndex) {
          content.classList.add('active');
        }
      });

      tabHeadings.forEach(item => {
        item.classList.remove('active');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('tabindex', '-1');
      });

      trigger.classList.add('active');
      trigger.setAttribute('aria-selected', 'true');
      trigger.removeAttribute('tabindex');
    }

    function selectNextTab(currentTab) {
      let nextIndex;

      if (currentTab === lastTab) {
        setActiveTab(firstTab);
      } else {
        nextIndex = tabHeadings.indexOf(currentTab) + 1;
        setActiveTab(tabHeadings[nextIndex]);
      }
    }

    function selectPreviousTab(currentTab) {
      let previousIndex;

      if (currentTab === firstTab) {
        setActiveTab(lastTab);
      } else {
        previousIndex = tabHeadings.indexOf(currentTab) - 1;
        setActiveTab(tabHeadings[previousIndex]);
      }
    }
  }
});